<rcl-menu id="rcl-menu" [(show)]="showMenu" role="menu" class="nav-menu">
  <rcl-menu-item id="rcl-menu__item-profile">
    <button
      id="item-profile__button"
      (click)="gaSettings($event)"
      aria-haspopup="true"
      role="menuitem"
      [tabindex]="showMenu() ? 0 : -1"
      >
      {{ bundle() && bundle()["header.user.menu.profile"] }}
    </button>
  </rcl-menu-item>

  <rcl-menu-item id="rcl-menu__item-reservations">
    <button
      id="item-reservations__button"
      (click)="gaCruises($event)"
      aria-haspopup="true"
      role="menuitem"
      [tabindex]="showMenu() ? 0 : -1"
      >
      {{ bundle() && bundle()["header.user.menu.reservations"] }}
    </button>
  </rcl-menu-item>

  <rcl-menu-item id="rcl-menu__item-cruise">
    <button
      id="item-cruise__button"
      (click)="getPastCruises()"
      aria-haspopup="true"
      role="menuitem"
      [tabindex]="showMenu() ? 0 : -1"
      >
      {{ bundle() && bundle()["button.past.cruise"] }}
    </button>
  </rcl-menu-item>

  @if (urlService.curtesyHolds()) {
    <rcl-menu-item id="rcl-menu__item-holds">
      <button
        id="item-holds__button"
        (click)="getCurtesyHolds()"
        aria-haspopup="true"
        role="menuitem"
        [tabindex]="showMenu() ? 0 : -1"
        >
        {{ bundle() && bundle()["button.curtesy.holds"] }}
      </button>
    </rcl-menu-item>
  }

  @if (urlService.royalGifts()) {
    <rcl-menu-item id="rcl-menu__item-gifts">
      <button
        id="item-gifts__button"
        (click)="getRoyalGifts()"
        aria-haspopup="true"
        role="menuitem"
        [tabindex]="showMenu() ? 0 : -1"
        >
        {{ bundle() && bundle()["header.user.menu.royal.gifts"] }}
      </button>
    </rcl-menu-item>
  }
  @if (displayMessageCenter()) {
    <rcl-menu-item id="rcl-menu__item-message-center">
      <!-- <rcl-menu-item id="rcl-menu__item-message-center"> -->
      <main-nav-message-center  
      [isProfileNav]="true"
      [myMessagesText]="bundle()['button.my.message']"
      (click)="openMessageCenterContainer()"
	    (keydown.enter)="openMessageCenterContainer()"
      (displayBadgeOnProfile)="displayBadgeOnProfile($event)"
      [isMobile]="true"
      [hideMessageCenterContainer]="!showMessageCenterContainer"
      ></main-nav-message-center>
    </rcl-menu-item>
  }
  <rcl-menu-item id="rcl-menu__item-help">
    <button
      id="item-help__button"
      (click)="getFaq()"
      role="menuitem"
      [tabindex]="showMenu() ? 0 : -1"
      >
      {{ bundle() && bundle()["button.help"] }}
    </button>
  </rcl-menu-item>

  <rcl-menu-item id="rcl-menu__item-sign-out">
    <button
      id="item-sign-out__button"
      (click)="signOut($event)"
      aria-haspopup="true"
      role="menuitem"
      [tabindex]="showMenu() ? 0 : -1"
      >
      {{ bundle() && bundle()["header.user.menu.sign.out"] }}
    </button>
  </rcl-menu-item>
</rcl-menu>
